package com.hyperether.goodjob.scenes.profile

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.hyperether.goodjob.repository.Repository
import kotlinx.coroutines.launch

class ProfileViewModel(val repository: Repository) : ViewModel() {

    init {
        repository.getToken().takeIf { it.isNotEmpty() }?.let {
            viewModelScope.launch {
                repository.getTeams()
            }

            viewModelScope.launch {
                repository.getUsers()
            }
        }
    }
}